import { Component, OnInit } from '@angular/core';
import { ProductService } from '@spartacus/core';
import { DashboardService } from '../_core/dashboard.service';
import { BehaviorSubject, map, switchMap, combineLatest } from 'rxjs';
import { mediaConfig } from '../../store-front/default-media.config';

@Component({
  selector: 'recent-buy-items',
  templateUrl: './recent-buy-items.component.html',
  styleUrl: './recent-buy-items.component.scss',
  standalone: false,
})
export class RecentBuyItemsComponent implements OnInit {
  products$ = new BehaviorSubject<any[]>([]);

  responsiveOptions = [
    {
      breakpoint: mediaConfig.mediaFormats!['widescreen'].width?.toString() + 'px',
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['desktop'].width?.toString() + 'px',
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['tablet'].width?.toString() + 'px',
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: mediaConfig.mediaFormats!['mobile'].width?.toString() + 'px',
      numVisible: 1,
      numScroll: 1,
    },
  ];
  constructor(
    private _dashboardService: DashboardService,
    private _productService: ProductService,
  ) {}

  ngOnInit(): void {
    this.getRecentBuyItems();
  }

  getRecentBuyItems() {
    this._dashboardService
      .getRecentBuyItems({ itemCount: 5 })
      .pipe(
        map(result => {
          return result.recentBuyItems?.map(product => product.partID) || [];
        }),
        switchMap(products => {
          return combineLatest(products.map(product => this._productService.get(product)));
        }),
      )
      .subscribe(data => this.products$.next(data));
  }
}
